import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import role from '../helpers/role';

import errorActions from '../store/actions/error';
import namespace from '../store/namespace';

import License from '../license/License.vue';
import Verification from '../verification/Verification.vue';
import LoginPage from '../auth/LoginPage.vue';
import Register from '../auth/Register.vue';
import Confirm from '../auth/Confirm.vue';
import ForgotPassword from '../auth/ForgotPassword.vue';
import ResetPassword from '../auth/ResetPassword.vue';
import Dashboard from '../dashboard/Dashboard.vue';
import Redirector from '../general/Redirector.vue';

import CometitionApprovalRoutes from './competitionApproval';
import CompetitionRoutes from './competition';
import BestListRoutes from './bestlist';
import CheckingsRoutes from './checking';
import PerformanceRoutes from './pefromance';
import UserManagerRoutes from './usermanager';
import RoleRequestRoutes from './role';
import EventRegistrationRoutes from './eventRegistration';
import RecordRoutes from './records';
import ManualBestlistRoutes from './manualBestlists';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	routes: [{
		path: '/license',
		name: 'license',
		component: License,
		meta: {
			authorize: [{ name: role.OrgAdmin }, { name: role.OrgUser }, { name: role.Official }, { name: role.Approver }],
		},
	}, {
		path: '/verification',
		name: 'verification',
		component: Verification,
		meta: {
			authorize: [],
		},
	}, {
		path: '/login',
		name: 'login',
		component: LoginPage,
	}, {
		path: '/register',
		name: 'register',
		component: Register,
	}, {
		path: '/forgotpassword',
		name: 'forgotpassword',
		component: ForgotPassword,
	}, {
		path: '/resetpassword',
		name: 'resetpassword',
		component: ResetPassword,
	}, {
		path: '/confirm',
		name: 'confirm',
		component: Confirm,
	}, {
		path: '/redirector',
		name: 'redirector',
		component: Redirector,
	}, {
		path: '/dashboard',
		name: 'dashboard',
		component: Dashboard,
	}, {
		path: '*',
		redirect: '/dashboard',
	}].concat(CometitionApprovalRoutes)
		.concat(CompetitionRoutes)
		.concat(BestListRoutes)
		.concat(CheckingsRoutes)
		.concat(PerformanceRoutes)
		.concat(UserManagerRoutes)
		.concat(RoleRequestRoutes)
		.concat(EventRegistrationRoutes)
		.concat(RecordRoutes)
		.concat(ManualBestlistRoutes),
});

router.beforeEach((to, _from, next) => {
	const { authorize } = to.meta;

	store.dispatch(`${namespace.ERROR}/${errorActions.REMOVE_ERROR}`);

	if (authorize) {
		const isAuthenticated = store.getters[`${namespace.AUTH}/IsAuthenticated`];
		const hasUser = store.getters[`${namespace.USER}/HasUser`];

		if (!isAuthenticated || !hasUser) {
			return next({
				path: '/dashboard',
				query: { redirect: to.fullPath },
			});
		}

		const roles = store.getters[`${namespace.USER}/Roles`];

		if (authorize.length
            && !authorize.some(x => roles.some(r => r.code === x.name)) && !(authorize.some(x => x.name === role.Any) && roles.length !== 0)) {
			return next({ path: '/dashboard' });
		}
	}

	return next();
});

export default router;
